<ng-container>
  <div class="page-title">
    <div [innerHTML]="'ObjectivesInfo.Title' | translate | safe:'html'" class="title"></div>
    <div class="sub-title">
      <div [innerHTML]="'ObjectivesInfo.SubTitle' | translate | safe:'html'"></div>
      <div *ngIf="!isValidObjectives() && this.submitted"
           [innerHTML]="'incorrectObjective' | translate"
           class="error d-m-none">
      </div>
    </div>
    <div [ngClass]="{'display': !isValidObjectives()}" class="hint">
      <span [innerHTML]="'ObjectivesInfo.Hint' | translate | safe:'html'"></span>
    </div>
  </div>

  <div class="objectives-container buttons-checkbox">
    <mat-checkbox (change)="updateUser()" [(ngModel)]="investmentModel.tradingProfits" [translate]="'tradingprofits'"
                  class="switch" name="tradingprofits">

      <div class="text-with-info">

        <div>{{ 'tradingprofits' | translate }}</div>
        <app-info-hint [text]="'tradingprofits.Info' | translate"></app-info-hint>

      </div>

    </mat-checkbox>

    <mat-checkbox (change)="updateUser()" [(ngModel)]="investmentModel.speculation" [translate]="'speculation'"
                  class="switch" name="speculation">
      <div class="text-with-info">
        <div>{{ 'speculation' | translate }}</div>
        <app-info-hint [text]="'speculation.Info' | translate"></app-info-hint>
      </div>
    </mat-checkbox>

    <mat-checkbox (change)="updateUser()" [(ngModel)]="investmentModel.hedging" [translate]="'hedging'"
                  class="switch" name="hedging">
      <div class="text-with-info">
        <div>{{ 'hedging' | translate }}</div>
        <app-info-hint [text]="'hedging.Info' | translate"></app-info-hint>
      </div>
    </mat-checkbox>

    <mat-checkbox (change)="updateUser()" [(ngModel)]="investmentModel.growth" [translate]="'growth'"
                  class="switch" name="growth">
      <div class="text-with-info">
        <div>{{ 'growth' | translate }}</div>
        <app-info-hint [text]="'growth.Info' | translate"></app-info-hint>
      </div>
    </mat-checkbox>
  </div>

  <div *ngIf="!isValidObjectives() && this.submitted"
       [innerHTML]="'incorrectObjective' | translate"
       class="error d-xl-none">
  </div>

</ng-container>

<ng-container>
  <div class="page-title">
    <div [innerHTML]="'ExperienceInfo.Title' | translate | safe:'html'" class="title">
    </div>
    <div class="sub-title">
      <div>{{ 'ExperienceInfo.SubTitle' | translate }}</div>
      <div *ngIf="isRequiredFields()" [innerHTML]="'ExperienceInfo.Errors.RequiredFields' | translate | safe:'html'"
           class="error d-m-none">
      </div>
    </div>
  </div>

  <form #productsFormElement [formGroup]="productsForm">
    <div class="row">
      <div class="data-field col-xl-3">
        <div class="label">
          <span [innerHTML]="'yearsExperience' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="setYearOfExperience(this.investmentModel.stocks,'stocks',0)"
                      formControlName="stocksYears"
                      name="stocksyearstrading">
            <mat-option *ngIf="!investmentModel.stocks.yearsTrading" value="">
              {{ 'yearsExperiencePlaceholder' | translate }}
            </mat-option>

            <mat-option *ngFor="let years of yearsTradingList" value="{{years.rangeValue}}">
              {{ years.rangeName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="isLowExperience('stocks')" [innerHTML]="'lowExperience' | translate | safe:'html'"
             class="error">
        </div>
      </div>
      <div class="data-field col-xl">
        <div class="label">
          <span [innerHTML]="'tradesPerYear' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="updateUser()"
                      [disabled]="!checkObjectiveExperience(this.investmentModel.stocks,0)"
                      formControlName="stocksTradesPerYear"
                      name="stockstradesperyear">
            <mat-option *ngIf="!investmentModel.stocks.tradesPerYear" value="">
              {{ 'tradesPerYearPlaceholder' | translate }}
            </mat-option>

            <mat-option *ngFor="let years of tradesPerYearList" value="{{years.rangeValue}}">{{ years.rangeName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="data-field col-xl">
        <div class="label">
          <span [innerHTML]="'knowledge' | translate | safe: 'html'"></span>
        </div>

        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="updateUser()"
                      [disabled]="!checkObjectiveExperience(this.investmentModel.stocks,0)"
                      formControlName="stocksKnowledge"
                      name="stocksknowledge">
            <mat-option *ngIf="!investmentModel.stocks.knowledgeLevel" value="">
              {{ 'knowledgePlaceholder' | translate }}
            </mat-option>

            <mat-option *ngFor="let years of knowledgeLevelList" [translate]="'stocksKnowledgeValue'" value="{{years}}">
              {{ years | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="isLowKnowledge('stocks')" [innerHTML]="'lowKnowledge' | translate | safe:'html'"
             class="error">
        </div>
      </div>

      <div *ngIf="isRequiredFields()" [innerHTML]="'ExperienceInfo.Errors.RequiredFields' | translate | safe:'html'"
           class="error">
      </div>

      <div *ngIf="isCashAccount('stocks')" class="field-info">
        <img alt="info" src="/img/info-icon.svg">
        <div [innerHTML]="'isCashAccount' | translate | safe:'html'"></div>
      </div>

    </div>
  </form>

  <div *ngIf="marginExperience()">
    <div class="margin-container">
      <div class="page-title">
        <div [innerHTML]="'ExperienceInfo.Margin.Title' | translate | safe:'html'" class="title">
        </div>
        <div class="sub-title">
          <span [innerHTML]="'ExperienceInfo.Margin.SubTitle' | translate | safe:'html'"></span>
        </div>
      </div>

      <section class="data-field">
        <mat-radio-group [(ngModel)]="investmentModel.stocks.marginExperience">
          <mat-radio-button [value]="false">
            <span [translate]="'toggleNo'">No</span>
          </mat-radio-button>
          <mat-radio-button [value]="true">
            <span [translate]="'toggleYes'">Yes</span>
          </mat-radio-button>
        </mat-radio-group>
      </section>

    </div>

  </div>
</ng-container>
